import {
  RESET_SIMULATED_BUSINESS_ACTIVITIES,
  SET_SIMULATED_BUSINESS_ACTIVITIES,
} from "../action.js";
import { simulatedBusinessActivities } from "./initial-store.js";

const initialState = simulatedBusinessActivities;

function simulatedActivitiesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIMULATED_BUSINESS_ACTIVITIES:
      return action.payload;
    case RESET_SIMULATED_BUSINESS_ACTIVITIES:
      return {};
    default:
      return state;
  }
}

export default simulatedActivitiesReducer;
